module.exports = __webpack_public_path__ + "static/media/nieruchomosci.07df7d1d.svg";